export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules-inner.vue?vue&type=template&id=6bc4fd0c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/rules/rules-inner.vue?vue&type=template&id=6bc4fd0c
// module id = v1hH
// module chunks = 0